import apiFetch from "../utils/apiFetch";

const VALID_ACCESS_MODES = new Set(["interactive", "read_only"]);

export async function fetchMemberProductExperience() {
  const data = await apiFetch("/api/me/product-experience");

  if (!Array.isArray(data?.products)) {
    throw new Error("invalid_product_experience_response");
  }

  const hasInvalidProduct = data.products.some(
    (product) =>
      !product?.id ||
      !VALID_ACCESS_MODES.has(product.access_mode) ||
      !Number.isFinite(Number(product.progress_percent ?? 0)),
  );

  if (hasInvalidProduct) {
    throw new Error("invalid_product_experience_contract");
  }

  return data.products;
}
